import { standardCachingQueryOptions } from 'pos-client/utils/standardCachingQueryOptions.ts';
import { trpc } from 'pos-client/utils/trpc.ts';

interface UseOrderJobProps {
  orderId: string;
  jobId: string;
}

export const useOrderJob = ({ orderId, jobId }: UseOrderJobProps) => {
  const response = trpc.orders.getOrderJob.useQuery(
    {
      orderId,
      jobId,
    },
    {
      ...standardCachingQueryOptions,
    }
  );

  const {
    data: orderJob,
    isLoading: isLoadingOrderJob,
    isFetching: isFetchingOrderJob,
    ...rest
  } = response;

  return {
    orderJob,
    isLoadingOrderJob,
    isFetchingOrderJob,
    ...rest,
  };
};
